/*
 * The storefront bundle — the entry point `bench build --app splashbox` compiles and
 * `templates/splashbox_base.html` pulls in with `include_script('splashbox.bundle.js')`.
 *
 * WHAT THE WHOLE BUNDLE IS FOR
 * ----------------------------
 * Nothing. That is the design. Every page of this storefront is complete before a
 * byte of this file runs: the set page prices itself and drops rows through a real
 * `<form method="get">`, the bag checks out through a real POST, sign-in runs its
 * whole three-step state machine as ordinary form posts, and the phone tab bar is
 * five plain anchors. A parent on a locked-down browser in a shop doorway loses
 * animation and a page reload, never a purchase.
 *
 * So this file's only job is to start six modules and to make sure that one of them
 * failing cannot take the others with it.
 *
 * WHY EACH MODULE IS STARTED INSIDE ITS OWN TRY
 * ---------------------------------------------
 * An exception thrown while wiring the menus would, in one shared `init()`, leave
 * the set page's remove buttons unbound — and an unbound remove button is not a dead
 * button, it is a REAL SUBMIT that reloads the page. That is a survivable failure
 * only because each module is independent, and it stays survivable only if one
 * module's bad day is caught before it reaches the next one. What is caught is
 * logged to the console and nowhere else: a customer must never be shown our
 * stack traces, and there is nothing here they could act on.
 *
 * ORDER MATTERS ONCE. `nav` first, because it paints the bag badge and the Bag links
 * from storage and the other modules refresh what it painted. Everything after that
 * is independent.
 *
 * NOTHING IS PUT ON `window`. esbuild bundles this as an IIFE
 * (frappe/esbuild/esbuild.js), so the module scope is the whole surface area, and a
 * global would be one more thing a page — or another app's script on the same
 * site — could reach into.
 */

import * as nav from "./js/nav.js";
import * as otp from "./js/otp.js";
import * as set from "./js/set.js";
import * as upi from "./js/upi.js";

/** Start one module. A module that throws is skipped, not fatal. */
function start(name, module) {
	try {
		module.init();
	} catch (error) {
		// `console.error` and not an Error Log: this runs on a customer's phone, the
		// page is already complete without us, and the shop cannot act on a browser
		// exception it never sees.
		if (window.console && window.console.error) {
			window.console.error("splashbox: " + name + " did not start", error);
		}
	}
}

function boot() {
	start("nav", nav);
	start("set", set);
	start("otp", otp);
	start("upi", upi);
}

/*
 * `include_script` emits a plain blocking `<script src>` at the end of `<body>`
 * (frappe/utils/jinja_globals.py:98), so the whole page above it is already parsed
 * and `boot()` can run immediately. The `readyState` guard is for the one case that
 * is not true of: a future template that moves the tag into `<head>`, or a `defer`
 * that arrives with it.
 */
if (document.readyState === "loading") {
	document.addEventListener("DOMContentLoaded", boot);
} else {
	boot();
}
